module.exports = __webpack_public_path__ + "img/chevron.100a70d5.svg";